import { AudienceType } from 'components/models/FormProps';

// How each audience type is named back to the form creator, as the object of
// "This form can only be sent to ...". The targeted/untargeted distinction is
// carried in the wording rather than in a separate label, because that is the
// distinction a pinned form creator is being denied.
const AudienceTypeToName: Record<AudienceType, string> = {
  [AudienceType.PUBLIC]: 'anyone with the link',
  [AudienceType.STUDENT]: 'targeted students',
  [AudienceType.UNTARGETED_STUDENT]: 'any student',
  [AudienceType.PARENT]: 'targeted custodians',
  [AudienceType.UNTARGETED_PARENT]: 'any custodian',
  [AudienceType.STAFF]: 'targeted staff',
  [AudienceType.UNTARGETED_STAFF]: 'any staff'
};

export function getAudienceTypeDisplayName(type: AudienceType | null | undefined): string | null {
  if (type == null) return null;

  return AudienceTypeToName[type] ?? null;
}
